<template>
  <v-dialog 
    v-model="dialog"
    persistent
    max-width="1300px"
  >
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Probations"
      text="Pending Action Probations"
      class="mb-0"
    >
      <v-row>
        <v-col>
          <v-data-table
            :headers="headers"
            :items="probation"
          >
            <template v-slot:item.start_date="{ item }">
              <span>{{ $moment(item.start_date).format('D MMM YYYY') }}</span>
            </template>
            <template v-slot:item.end_date="{ item }">
              <span>{{ $moment(item.end_date).format('D MMM YYYY') }}</span>
            </template>

            <template v-slot:item.pass_or_fail="{ item }">
              <span
                v-if="item.pass_or_fail"
                class="font-weight-bold green--text"
              > Pass</span>
              <span
                v-else-if="item.pass_or_fail === null"
                class="font-weight-bold warning--text"
              > Pending Action</span>
              <span
                v-else
                class="font-weight-bold error--text"
              >Failed</span>
            </template>

            <template v-slot:item.action="{ item }">
              <probation-pending-dialog-confirm
                v-if="$hasPermissionTo(['confirm probations'])"
                :probation="item"
                @confirmed="$emit('load')"
              />
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <v-card-actions class="py-0">
        <v-spacer />
        <v-btn
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      ProbationPendingDialogConfirm: () => import('@/components/hris/probation/pending/DialogConfirm'),
    },
    props: {
      probation: {
        type: Array,
        default: null,
      },  
    },
    data () {
      return {
        dialog: true,
        headers: [
          {
            text: 'Employee',
            align: 'left',
            value: 'employee.person.name',
          },
          {
            text: 'Probation Start Date',
            align: 'center',
            value: 'start_date',
          },
          {
            text: 'Probation End Date',
            align: 'center',
            value: 'end_date',
          },
          {
            text: 'Department',
            align: 'left',
            value: 'department.name',
          },
          {
            text: 'Position',
            align: 'left',
            value: 'position.name',
          },
          {
            text: 'Status',
            align: 'center',
            value: 'pass_or_fail',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
      }
    },
  }
</script>
